import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/bwm',
  headers: { 'x-api-key': process.env.REACT_APP_API_KEY || '' },
});

const authHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

const SOURCE = 'build-with-mak-page';

export const getAbout = () =>
  api.get('/about', { params: { source: SOURCE } }).then((r) => r.data);

export const updateAbout = (token, data) =>
  api.put('/about', data, {
    params: { source: SOURCE },
    ...authHeader(token),
  }).then((r) => r.data);
